export const supportEmail = "charsmithapp@gmail.com";
export const patreonLink =
  "https://patreon.com/charsmith?utm_medium=unknown&utm_source=join_link&utm_campaign=creatorshare_creator&utm_content=copyLink";
export const purchaseLink =
  "https://www.myth.works/collections/the-wildsea-homepage";

export const stableLink = "https://wildsea-charsmith-stable.netlify.app";
